import { detectDeviceRenderScaleCap } from "./device-render-scale-cap";

export const DEVICE_RENDER_SCALE_CAP = detectDeviceRenderScaleCap();
